import React from 'react';

interface SectionTitleProps {
  icon: React.ComponentType<any> | string;
  title: string;
  colors?: any;
}

export const SectionTitle: React.FC<SectionTitleProps> = ({
  icon: Icon,
  title,
  colors = {}
}) => {
  const defaultColors = {
    titleText: "#DDB889",
    subtitleText: "#DDB889CC",
    iconColor: "#DDB889",
    sectionDividerGradient: "#DDB88944"
  };

  // Merge default colors with provided colors
  const mergedColors = { ...defaultColors, ...colors };

  // Create dynamic gradient styles
  const leftGradientStyle = {
    backgroundImage: `linear-gradient(to right, transparent, ${mergedColors.sectionDividerGradient})`
  };

  const rightGradientStyle = {
    backgroundImage: `linear-gradient(to left, transparent, ${mergedColors.sectionDividerGradient})`
  };

  const iconStyle = {
    color: mergedColors.iconColor
  };

  const titleStyle = {
    color: mergedColors.titleText
  };

  const titleTextStyle = {
    color: mergedColors.subtitleText
  };

  const titleTextHoverStyle = {
    color: mergedColors.titleText
  };

  return (
    <div className="lp-flex lp-items-center lp-justify-center lp-mb-6 lp-group">
      <div className="lp-flex lp-items-center lp-space-x-6">
        <div
          className="lp-h-[1px] lp-w-16 lp-bg-gradient-to-r lp-from-transparent lp-transition-all lp-duration-700 group-hover:lp-w-20"
          style={leftGradientStyle}
        ></div>

        <h4
          className="lp-text-xl lp-font-medium lp-flex lp-items-center lp-transition-transform lp-duration-200 group-hover:lp-scale-105"
          style={titleStyle}
        >
          {typeof Icon === 'string' ? (
            <span
              className="lp-mr-3 lp-shrink-0 lp-transition-transform lp-duration-200 group-hover:lp-scale-110"
              style={iconStyle}
            >
              {Icon}
            </span>
          ) : (
            <Icon
              className="lp-mr-3 lp-shrink-0 lp-transition-transform lp-duration-200 group-hover:lp-scale-110"
              style={iconStyle}
              size={24}
            />
          )}
          <span
            className="lp-truncate lp-transition-colors lp-duration-200 group-hover:lp-text-[#DDB889]"
            style={titleTextStyle}
          >
            {title}
          </span>
        </h4>

        <div
          className="lp-h-[1px] lp-w-16 lp-bg-gradient-to-l lp-from-transparent lp-transition-all lp-duration-700 group-hover:lp-w-20"
          style={rightGradientStyle}
        ></div>
      </div>
    </div>
  );
};
